import { type FC } from 'react';
import { useIntl } from 'react-intl';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LightbulbOutlined from '@mui/icons-material/LightbulbOutlined';

// screen
import StatCard from 'modules/dashboard/components/StatCard';
import type { MenuDishStatisticsResponse } from 'modules/dashboard/types';

interface Props {
  data?: MenuDishStatisticsResponse | null;
}

/**
 * Khối "Khai thác ngân hàng thực đơn": tổng món dùng / món chế biến / món không chế biến.
 * Tử số = customer_usage.unique_* (món trường dùng, distinct theo tên);
 * mẫu số = customer_usage.*_dish_usages (số món dùng trên các thực đơn của TRƯỜNG trong tháng đó),
 * KHÔNG phải tổng ngân hàng thực đơn toàn hệ thống (global_catalog).
 */
const MenuUsageCards: FC<Props> = ({ data }) => {
  const { formatMessage } = useIntl();

  const usage = data?.customer_usage ?? null;

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 600, mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <LightbulbOutlined fontSize="small" />
        {formatMessage({ id: 'dashboard.usage.sectionTitle' })}
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 2 }}>
        <StatCard
          label={formatMessage({ id: 'dashboard.usage.totalDishes' })}
          numerator={usage?.unique_dish_count ?? null}
          denominator={usage?.total_dish_usages ?? null}
        />
        <StatCard
          label={formatMessage({ id: 'dashboard.usage.processingDishes' })}
          numerator={usage?.unique_processing_dish_count ?? null}
          denominator={usage?.processing_dish_usages ?? null}
        />
        <StatCard
          label={formatMessage({ id: 'dashboard.usage.packedDishes' })}
          numerator={usage?.unique_packed_dish_count ?? null}
          denominator={usage?.packed_dish_usages ?? null}
        />
      </Box>
    </Box>
  );
};

export default MenuUsageCards;
